var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('models/roles/RoleModel',['require','underscore','evertrue','ET/ETModel'],function(require) {
  var ETModel, EverTrue, RoleModel, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ETModel = require("ET/ETModel");
  return RoleModel = (function(_super) {
    __extends(RoleModel, _super);

    function RoleModel() {
      return RoleModel.__super__.constructor.apply(this, arguments);
    }

    RoleModel.prototype.urlRoot = "auth/roles";

    RoleModel.prototype.defaults = {
      name: null,
      "default": false
    };

    RoleModel.prototype.setOrganization = function(oid) {
      this.urlOverride = {};
      return this.urlOverride.params = {
        oid: oid
      };
    };

    RoleModel.prototype.save = function(attrs, options) {
      this.unset("organization_id", {
        silent: true
      });
      attrs = _.omit(attrs, "organization_id");
      return RoleModel.__super__.save.call(this, attrs, options);
    };

    return RoleModel;

  })(ETModel);
});

//# sourceMappingURL=RoleModel.js.map
;
